import { Component, OnInit } from '@angular/core';
import { CandidatesService, AuthService } from '../../services';
import { Router , ActivatedRoute} from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
    etst : Date = new Date();
    focus;
    focus1;
    candidate : any = {
    	first_name : null,
		last_name : null,
		gender: 'm',
		maritial_status: 's',
		address_email : null,
		password : ''
    };
    c_password = null;
    isLoading  = false;
    existBefore = false;
    normalRegistation = true;
    resetCode = null
    constructor(private route : ActivatedRoute, private toastr : ToastrService, private router: Router, private apiService : CandidatesService, private authService : AuthService) {
        
        this.route.queryParams.subscribe(params => {
                if(params['reset_code']){
                    this.resetCode = params['reset_code'];
                    this.normalRegistation = false;
                }
        });
    }

    ngOnInit() {}

    canSubmit(type = 'signup'){
        if(type == 'signup')
    	    return this.candidate.first_name != null && this.candidate.last_name != null && this.candidate.address_email != null && this.candidate.password == this.c_password 
        else
            return this.candidate.password == this.c_password 
    }

    register(){
    	this.isLoading = true;
	  	this.apiService.register(this.candidate).subscribe((res: any) =>{
              console.log(res)
	  		this.isLoading = false;
	  		this.authService.user = res.data;
	      	this.router.navigate(['/user-profile']);
	    },
	    (error) => {
	    	this.isLoading = false;
	    	if (error?.error?.message == "Email Already Exist !")
	    		this.existBefore = true;
            this.toastr.error(error?.error?.message, "Registration");
	    });
    }

    updatePassword(){
        this.isLoading = true;
          this.apiService.updatePassword({password:this.candidate.password,reset_code:this.resetCode}).subscribe((res: any) =>{
              this.isLoading = false;
              this.authService.user = res.data;
              this.router.navigate(['/']);
        },
        (error) => {
            this.isLoading = false;
            this.toastr.error(error?.error?.message, "Update Password");
        });
    }
}
